<template>
  <base-modal
    :is-open="isOpen"
    :modal-title="modalTitle"
    size="md"
    @onClose="$emit('onClose')"
    titleSubmit="Integrate"
    :useCancel="true"
    :forceLoading="modal.loading"
    @onSubmit="submitForm"
  >
    <div class="container py-3 px-4">
      <div class="row">
        <div class="col-12">
          <div class="d-flex align-items-center mb-2 p-2 rounded-3">
            <form @submit.prevent="submitForm">
              <div class="row g-3 d-flex flex-column">
                <label
                  >You will be directed to your TikTok Business Portal. Complete
                  all steps to Integration.</label
                >
                <!-- <div class="form-group col-lg-12 mt-3">
                  <h6 class="fw-3">App ID</h6>
                  <input
                    type="text"
                    name="portal_app_id"
                    class="form-control"
                    id="portal-app-id"
                    v-model="form.portal_app_id"
                    placeholder="Portal App ID"
                  />
                </div> -->
                <div class="mt-3">
                  <label for="tasksTitle-field" class="form-label"
                    >App ID</label
                  >

                  <input
                    :type="appIdType"
                    name="portal_app_id"
                    class="form-control pe-5"
                    id="portal_app_id"
                    v-model="form.portal_app_id"
                    placeholder="Portal App ID"
                    required
                  />
                  <i
                    :class="`img-prepend pointer ${
                      appIdType == 'text' ? 'ri-eye-off-line' : 'ri-eye-line'
                    }`"
                    @click="toggleType('appIdType')"
                  ></i>
                </div>
                <div class="mt-0">
                  <label for="tasksTitle-field" class="form-label"
                    >App Secret</label
                  >

                  <input
                    :type="appSecretType"
                    name="tiktok_app_secret"
                    class="form-control pe-5"
                    id="tiktok_app_secret"
                    v-model="form.tiktok_app_secret"
                    placeholder="App Secret"
                    required
                  />
                  <i
                    :class="`img-prepend pointer ${
                      appSecretType == 'text'
                        ? 'ri-eye-off-line'
                        : 'ri-eye-line'
                    }`"
                    @click="toggleType('appSecretType')"
                  ></i>
                </div>
                <div class="col-lg-12 mt-0">
                  <label class="form-label">Bot Type: </label>
                  <v-select
                      label="name"
                      v-model="form.bot_type"
                      :options="['normal', 'assistant', 'agent']"
                  ></v-select>
                </div>
                <div class="form-group col-lg-12" v-if="form.id">
                  <label>Bot: </label>
                  <v-select
                    label="name"
                    v-model="form.bot_id"
                    :options="listBot"
                    :reduce="(provider) => provider.id"
                  ></v-select>
                </div>
                <div class="mt-3">
                  <label for="tasksTitle-field" class="form-label"
                    >Authorize Webhook URL</label
                  >
                  <p class="text-muted">
                    You can use this Authorize webhook URL to set up webhook URL
                    authorization on your TikTok API service.
                  </p>

                  <input
                    type="text"
                    readonly=""
                    id="webhook-authorize-url"
                    key="webhook-authorize-url"
                    v-model="form.webhookAuthorizeUrl"
                    class="form-control pe-5"
                    required=""
                  />
                  <i
                    class="ri-file-copy-line img-prepend pointer"
                    @click="handleCopy(form.webhookAuthorizeUrl)"
                  ></i>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </base-modal>
</template>
<script>
import { isEmpty, debounce } from "lodash";
import { AccountService } from "@/services";
import { mapGetters } from "vuex";
import vSelect from "vue-select";

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    formTiktok: {
      type: Object,
    },
    modalTitle: {
      type: String,
      default: "Add TikTok Integration",
    },
  },
  components: {
    vSelect,
  },
  computed: {
    ...mapGetters({
      botList: "bot/botList",
      assistantList: "gen-ai/assistant",
      agenticList: "gen-ai/agentStore",
      businessUnit: "ticket/getBranchOffice",
      groupManagement: "ticket/getGroupManagement",
    }),
    localStorage() {
      return this.$store.getters.localStorage;
    },
    listBot() {
      if (this.form.bot_type == "assistant") {
        return this.assistantList;
      } else if (this.form.bot_type == "agent") {
        return this.agenticList;
      } else {
        return this.botList;
      }
    },
  },
  data() {
    return {
      // isOpen: this.showModal,
      isEmpty,
      data: {},
      appIdType: "password",
      appSecretType: "password",
      form: {
        userAccessToken: null,
        pageList: [],
        pageAccessToken: null,
        pageId: null,
        status: false,
        page: null,
        accountName: null,
        accountId: null,
        pageName: null,
        channelName: "tiktok",
        business_unit_id: null,
        bot_id: null,
        bot_type: null,
        group_id: null,
        webhookAuthorizeUrl: "",
      },
      formData: {},
      submitLoading: false,
      integrationId: null,
      pageLoading: false,
      business_unit: null,
      bot: null,
      group: null,
      modal: {
        delete: false,
        loading: false,
      },
    };
  },
  watch: {
    showModal(newVal) {
      // console.log("oy");
      if (newVal) {
        this.onShowModal();
      } else {
        this.onHideModal();
      }
    },
    isOpen: {
      handler(newVal) {
        if (newVal) {
          this.form = { ...this.form, ...this.$props.formTiktok };
          this.form.webhookAuthorizeUrl =
            import.meta.env.VITE_OMNICHANNEL_URL +
            "/api/" +
            this.$route.params.appId +
            "/authorize-webhook/tiktok/" +
            this.form.id;
        }
      },
    },
  },
  methods: {
    toggleType(key) {
      this[key] = this[key] == "password" ? "text" : "password";
    },
    handleCopy(text) {
      if (navigator.clipboard && window.isSecureContext) {
        // Cara modern
        navigator.clipboard
          .writeText(text)
          .then(() => {
            console.log("Text berhasil di-copy");
          })
          .catch((err) => {
            console.error("Gagal copy:", err);
          });

      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.left = "-999999px";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        try {
          document.execCommand("copy");
          console.log("Text berhasil di-copy");
        } catch (err) {
          console.error("Gagal copy:", err);
        }
        document.body.removeChild(textarea);
      }
    },
    changeValueBot(val) {
      this.form.bot_type = val;
    },
    changeValueBotList(val) {
      // console.log("bot:", val);
      this.bot = val.name;
      this.form.bot_id = val.id;
      this.formData.bot = val.name;
    },
    toggleDisconnect() {
      this.modal.delete = true;
    },
    async disconnectChannel() {
      this.modal.loading = true;
      try {
        let response = await this.$axios.delete(
          `api/${this.$store.getters.appId.hashed}/v3/remove-integration`,
          {
            params: {
              integrationId: this.integrationId,
            },
          }
        );
        const res = response.data;
        this.modal.loading = false;
        this.modal.delete = false;
        // this.emitter.$emit("hideIntegrationModal");
        this.successToast("Channel disconected");
        this.form.status = false;
        await this.clearForm();
        // document.location.reload();
      } catch (error) {
        this.modal.loading = false;
        this.modal.delete = false;
        this.form.status = !this.form.status;
        this.errorToast(error);
      }
    },
    async submitForm() {
      this.submitLoading = true;
      try {
        let formData = {
          ...this.form,
          status: true,
        };

        let response = await this.$axios.post(
          `api/${this.$store.getters.appId.hashed}/integrate`,
          formData
        );
        this.form.status = true;
        this.form.channelName = "tiktok";
        this.form.portal_app_id = formData.portal_app_id
          ? formData.portal_app_id
          : null;
        this.form.tiktok_app_secret = formData.tiktok_app_secret;
        this.submitLoading = false;

        this.successToast(response.data.message);
        this.$emit("onAdd");

        if (formData.id !== null && formData.id !== undefined) {
          window.location.href = `https://www.tiktok.com/v2/auth/authorize?client_key=${this.form.portal_app_id}&scope=user.info.basic%2Cuser.info.username%2Cuser.info.stats%2Cuser.info.profile%2Cuser.account.type%2Cuser.insights%2Cvideo.list%2Cvideo.insights%2Ccomment.list%2Ccomment.list.manage%2Cvideo.publish%2Cvideo.upload%2Cbiz.spark.auth%2Cdiscovery.search.words%2Cbiz.brand.insights%2Cmessage.list.read%2Cmessage.list.send%2Cmessage.list.manage&response_type=code&redirect_uri=${this.form.webhookAuthorizeUrl}`;
        }

        this.clearForm();
        this.$emit("onClose")

      } catch (error) {
        // console.log("error", error.message);
        // console.log("error", error.response.data.message);
        this.submitLoading = false;
        this.errorToast(error.response.data.message);
        // this.logoutFB();
        this.$emit("onClose");
      }
    },
    async clearForm() {
      this.form.portal_app_id = null;
      this.form.tiktok_app_secret = null;
      this.business_unit = null;
      this.form.group_id = null;
      this.group = null;
      this.integrationId = null;
    },
    async toggleIntegration(data) {
      let param = {
        integrationId: data.id,
        status: data.status,
      };
      this.submitToggle(param, this);
    },
    submitToggle: debounce(async (param, vm) => {
      await vm.$store.dispatch("integration/enableDisableIntegration", param);
      vm.fetchData();
    }, 300),
    editSubmit: debounce(async (vm) => {
      vm.$emit("onSubmit", vm.form);
    }, 300),
  },
  async mounted() {
    // this.fetchData();
  },
};
</script>
